import { useEffect, useState, Fragment } from 'react';
import { useTranslation } from '@nextgen-web-framework/all';
import { getTimeDifference, CountDownInterface } from '../../utils/countDownUtil';
import styles from './CountdownTimer.module.scss';
import type { CountdownTimerProps } from './types/propsTypes';
const CountdownTimer = ({ endTime, title, customClass }: CountdownTimerProps) => {
  const t = useTranslation();
  type CountDownTimer = 'hours' | 'minutes' | 'seconds';
  const [countdown, setCountdown] = useState<CountDownInterface>({
    hours: 0,
    minutes: 0,
    seconds: 0,
    isAhead: false,
  });

  const calculateTimeDifference = () => {
    setCountdown(getTimeDifference(endTime));
  };

  useEffect(() => {
    calculateTimeDifference(); // Initial calculation

    // Update countdown every second
    const intervalId = setInterval(calculateTimeDifference, 1000);

    // Cleanup interval on component unmount
    return () => clearInterval(intervalId);
  }, [endTime]);
  const formatCountdownValue = (value: number) => String(value).padStart(2, '0');

  const { isAhead } = countdown;

  if (isAhead) {
    return (
      <div className={`${styles['timer-block']} ${customClass}`}>
        <span className={styles['time-countdown-title']} data-testid="countdown_title_testId">
          {title ?? t(`web.countdowntimer.title`)}
        </span>
        {(['hours', 'minutes', 'seconds'] as CountDownTimer[]).map((unit, index, array) => (
          <Fragment key={unit}>
            <span className={styles['time-info-block']}>{formatCountdownValue(countdown[unit])}</span>
            {index !== array.length - 1 && <span className={styles['separator-dot']}>:</span>}
          </Fragment>
        ))}
      </div>
    );
  }
  return null;
};

export default CountdownTimer;
